import {Action} from '@ngrx/store';

export class LogoutAction implements Action {
  public static readonly type = 'LogoutAction';

  public type = LogoutAction.type;
}
